import { getWindowObject } from '@eventbrite/feature-detection';
import { checkGate, initializeSdk } from '@eventbrite/statsig';

// Statsig's Feature Gates
export const DISPLAY_ORGANIZER_RATING_GATE = 'listing_display_organizer_rating';

const getDomain = () => {
    return getWindowObject('__SERVER_DATA__')?.env?.ebDomain;
};
export const initializeStatsigSdk = async () => {
    await initializeSdk({
        user: {
            custom: {
                ebDomain: getDomain(),
            },
        },
    });
};

export const isDisplayRatingFeatureGateEnabled = () => {
    return checkGate(DISPLAY_ORGANIZER_RATING_GATE);
};
